import { render, staticRenderFns } from "./custom-img.vue?vue&type=template&id=04f8521a"
import script from "./custom-img.vue?vue&type=script&lang=js"
export * from "./custom-img.vue?vue&type=script&lang=js"
import style0 from "./custom-img.vue?vue&type=style&index=0&id=04f8521a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports